import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import routes, { unauthenticatedRoutes } from '../../routes';
import RouteWrapper from './RouteWrapper.jsx';

const PlatformRouter = (props) => {
  const { isLoggedIn, isLoaded, isEmbeddedEndUser } = props;

  // Desktop auth completion must be routable even when the user is already logged in,
  // otherwise /login?desktopPort&desktopState can't complete the loopback callback.
  const desktopAuthCompleteRoute = unauthenticatedRoutes.find((route) => route.path === '/desktop-auth/complete');
  const loginRoute = unauthenticatedRoutes.find((route) => route.path === '/login/*');
  const unauthRoutesSansDesktop = unauthenticatedRoutes.filter((route) => route.path !== '/desktop-auth/complete' && route.path !== '/login/*');
  const loginFallbackElement = loginRoute && isLoaded ? <RouteWrapper routeId={loginRoute.id} routeSlug={loginRoute.routeId} element={loginRoute.element} fixedWidth={loginRoute.fixedWidth} permissions={loginRoute.permissions} /> : null;

  return (
    <Suspense fallback={<span />}>
      <Routes>
        {desktopAuthCompleteRoute ? <Route key={'route-desktop-auth-complete'} path={desktopAuthCompleteRoute.path} element={<RouteWrapper routeId={desktopAuthCompleteRoute.id} routeSlug={desktopAuthCompleteRoute.routeId} element={desktopAuthCompleteRoute.element} fixedWidth={desktopAuthCompleteRoute.fixedWidth} permissions={desktopAuthCompleteRoute.permissions} />} /> : null}

        {loginRoute ? <Route key={'route-login-explicit'} path={loginRoute.path} element={<RouteWrapper routeId={loginRoute.id} routeSlug={loginRoute.routeId} element={loginRoute.element} fixedWidth={loginRoute.fixedWidth} permissions={loginRoute.permissions} />} /> : null}

        {!isLoggedIn && (
          <>
            {unauthRoutesSansDesktop.map((route, idx) => (
              <Route
                key={`route-${idx}`}
                path={route.path}
                element={
                  <RouteWrapper routeId={route.id} routeSlug={route.routeId} element={route.element} fixedWidth={route.fixedWidth} permissions={route.permissions} /> //
                }
              />
            ))}
            {routes
              .filter((route) => route.routeId === 'oauth')
              .map((route, idx) => (
                <Route
                  key={`oauth-route-${idx}`}
                  path={route.path}
                  element={
                    <RouteWrapper routeId={route.id} routeSlug={route.routeId} element={route.element} fixedWidth={route.fixedWidth} permissions={route.permissions} /> //
                  }
                />
              ))}
            <Route key={'route-login'} path="*" element={loginFallbackElement} />
          </>
        )}
        {isLoggedIn &&
          !isEmbeddedEndUser &&
          routes.map((route, idx) => (
            <Route
              key={`route-${idx}`}
              path={route.path}
              element={
                <RouteWrapper routeId={route.id} routeSlug={route.routeId} element={route.element} fixedWidth={route.fixedWidth} route={route} permissions={route.permissions} /> //
              }
            />
          ))}
      </Routes>
    </Suspense>
  );
};

export default PlatformRouter;
